import { FC } from 'react';
import { Text,DetailText} from '../units/Text';
import './Inputs.css'
import { ChoicesProps } from '../Rest/Commission';
import { Tag } from '../units/Text';
import { BoxWrapper, FlexWrapper } from '../Wrappers/Wrappers';
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import {FormInputErrorEnum, FormInputProps} from './interfaces/FormInput';
import { getErrorText } from './utils/getErrorText';
import { useState } from 'react';

export const LgFormInput: FC<FormInputProps> = ({ value, label, name, inputError=null, required, valueSetter, type='text', helper='', className='', disabled=false, maxLength=undefined, pattern=undefined, isPassword=false}) => {
    const inputClassName = inputError === null 
        ? `cs-input cs-input-lg standart-border ${className}`
        : `cs-input cs-input-lg standart-border ${className} cs-input-error`

    return (
        <div className='flex flex-column narrow-gap' style={{width: '100%'}}>
            <Text size='base'>{label}{ required ? ( <span className='required-star'>*</span> ) : ('') } </Text>
            <input 
                disabled={disabled} 
                value={value === null || value === undefined ? '' : value} 
                type={type} 
                required={required} 
                placeholder={helper} 
                name={name} 
                id={name} 
                className={inputClassName} 
                onChange={valueSetter}
                maxLength={maxLength}
                pattern={pattern}
            />
            { inputError && <Text color='danger'>⚠️ {getErrorText(inputError)}</Text>}
        </div>
    )
}

export const LgFormInputPassword: FC<FormInputProps> = ({
  value,
  label,
  name,
  inputError = null,
  required,
  valueSetter,
  type = 'text',
  helper = '',
  className = '',
  disabled = false,
  maxLength = undefined,
  pattern = undefined,
  isPassword = false,
}) => {
  const [showPassword, setShowPassword] = useState(false)

  const inputClassName =
    inputError === null
      ? `cs-input cs-input-lg standart-border ${className}`
      : `cs-input cs-input-lg standart-border ${className} cs-input-error`

  const inputType = isPassword ? (showPassword ? 'text' : 'password') : type

  return (
    <div className="flex flex-column narrow-gap" style={{ width: '100%' }}>
      <Text size="base">
        {label}
        {required ? <span className="required-star">*</span> : ''}
      </Text>

      <div style={{ position: 'relative', width: '100%' }}>
        <input
          disabled={disabled}
          value={value === null || value === undefined ? '' : value}
          type={inputType}
          required={required}
          placeholder={helper}
          name={name}
          id={name}
          className={inputClassName}
          onChange={valueSetter}
          maxLength={maxLength}
          pattern={pattern}
          autoComplete={isPassword ? 'current-password' : undefined}
        />

        {isPassword && (
          <button
            type="button"
            disabled={disabled}
            onClick={() => setShowPassword((v) => !v)}
            aria-label={showPassword ? 'Hide password' : 'Show password'}
            style={{
              position: 'absolute',
              right: 12,
              top: '50%',
              transform: 'translateY(-50%)',
              background: 'none',
              border: 'none',
              cursor: disabled ? 'not-allowed' : 'pointer',
              padding: 0,
            }}
          >
            {showPassword ? '🔓' : '🔒'}
          </button>
        )}
      </div>

      {inputError && <Text color="danger">⚠️ {getErrorText(inputError)}</Text>}
    </div>
  )
}

// Refactor setter

interface UniversalFormInputProps {
    value?: string;
    label?: string;
    setter?: {
        setValue: (action: string, key: string, value: any) => void;
        action: string;
        key: string;
    }
    name: string;
    inputError?: FormInputErrorEnum;
    required: boolean;
    type: 'text' | 'password' | 'number';
    helper?: string;
    className?: string;
    disabled?: boolean;
    height?: 'cs-input-lg' | 'cs-input-base';
}


export const UniversalFormInput: FC<UniversalFormInputProps> = ({
    inputError=null, 
    type='text', 
    helper='', 
    className='', 
    disabled=false, 
    height='cs-input-lg',
    ...props
}) => {
    const baseClass = "cs-input standart-border"
    const inputClassName =  `${baseClass} ${height} full-width ${inputError ? 'cs-input-error' : ''} ${className}`.trim()

    const handleChange = (e: any) => {
        if (props.setter) {
            props.setter.setValue(props.setter.action, props.setter.key, e.target.value)
        }
    }
    
    return (
        <div className='flex flex-column narrow-gap full-width'>
            { props?.label && ( 
                <Text size='base'>
                    {props.label}{ props.required ? ( <span className='required-star'>*</span> ) : ('') }
                </Text> 
            )} 
            <input
                onChange={ handleChange }
                value={props.value ?? props.value }
                disabled={disabled} 
                type={type} 
                required={props.required} 
                placeholder={helper} 
                name={props.name} 
                id={props.name} 
                className={inputClassName} 
            />
            { inputError && (
                <Text color='danger'>⚠️ {getErrorText(inputError)}</Text>
            )}
        </div>
    )
}

export interface InputProps {
    value?: string;
    label?: string;
    setter?: (value: any) => any
    name: string;
    inputError?: string;
    required: boolean;
    type: 'text' | 'password' | 'number';
    helper?: string;
    className?: string;
    disabled?: boolean;
    height?: 'cs-input-lg' | 'cs-input-base';
    pattern?: string;
    showErros?: boolean
}

// For now the most advenced form of input
export const Input: FC<InputProps> = ({
    inputError=undefined, 
    type='text', 
    helper='', 
    className='', 
    disabled=false,
    showErros=true,
    height='cs-input-lg',
    ...props
}) => {
    const baseClass = "cs-input standart-border"
    const inputClassName =  `${baseClass} ${height} full-width ${inputError ? 'cs-input-error' : ''} ${className}`.trim()
    
    return (
        <div className='flex full-width flex-column narrow-gap'>
            { props?.label && ( 
                <Text size='base'>
                    {props.label}{ props.required ? ( <span className='required-star'>*</span> ) : ('') }
                </Text> 
            )} 
            <input
                onChange={props.setter}
                value={props.value ?? props.value }
                disabled={disabled} 
                type={type} 
                required={props.required} 
                placeholder={helper} 
                name={props.name} 
                id={props.name} 
                className={inputClassName} 
                pattern={props.pattern ?? props.pattern}
            />
            { showErros &&
                <BoxWrapper style={{height: "17px"}} p="p0">
                    { inputError ? (
                        <Text color='danger' size='sm' className='p0'>⚠️ {inputError}</Text> ):( <Text color='danger' size='sm' className='p0'>{''}</Text>
                    )}
                </BoxWrapper>
            }
        </div>
    )
}

export const PhoneInput_: FC<InputProps> = ({
    inputError=undefined, 
    type='text', 
    helper='', 
    className='', 
    disabled=false,
    showErros=true,
    height='cs-input-lg',
    ...props
}) => {
    const baseClass = "cs-input standart-border"
    const inputClassName =  `${baseClass} ${height} full-width ${inputError ? 'cs-input-error' : ''} ${className}`.trim()
    
    return (
        <div className='flex full-width flex-column narrow-gap'>
            { props?.label && ( 
                <Text size='base'>
                    {props.label}{ props.required ? ( <span className='required-star'>*</span> ) : ('') }
                </Text> 
            )}
            <PhoneInput
                onChange={props.setter}
                value={props.value ?? props.value }
                disabled={disabled}
                country={"ru"}
                placeholder={helper} 
            />
            { showErros &&
                <BoxWrapper style={{height: "17px"}} p="p0">
                    { inputError ? (
                        <Text color='danger' size='sm' className='p0'>⚠️ {inputError}</Text> ):( <Text color='danger' size='sm' className='p0'>{''}</Text>
                    )}
                </BoxWrapper>
            }
        </div>
    )
}


interface PasswordProps extends InputProps {
    setRestore: (value: any) => void;
}

export const PasswordInput: FC<PasswordProps> = ({
    inputError=undefined, 
    type='text', 
    helper='', 
    className='', 
    disabled=false, 
    height='cs-input-lg',
    ...props
}) => {
    const baseClass = "cs-input standart-border"
    const inputClassName =  `${baseClass} ${height} full-width ${inputError ? 'cs-input-error' : ''} ${className}`.trim()
    
    return (
        <div className='flex flex-column narrow-gap full-width'>
            { props?.label && ( 
                <Text size='base'>
                    {props.label}{ props.required ? ( <span className='required-star'>*</span> ) : ('') }
                </Text> 
            )} 
            <input
                onChange={props.setter}
                value={props.value ?? props.value }
                disabled={disabled} 
                type={type} 
                required={props.required} 
                placeholder={helper} 
                name={props.name} 
                id={props.name} 
                className={inputClassName} 
            />
            <BoxWrapper style={{height: "17px"}} p="p0">
                <FlexWrapper justifyContent='flex-start'>
                    { inputError ? (
                        <Text color='danger' size='sm' className='p0'>⚠️ {inputError}</Text> 
                    ):( 
                        <Text color='danger' size='sm' className='p0'>{''}</Text>
                    )}
                    {/* <Text size='sm' 
                        style={{borderBottom: "1px solid #333", cursor: "pointer"}}
                        onClick={ props.setRestore }
                        >Забыли Пароль?</Text> */}
                </FlexWrapper>
                
            </BoxWrapper>
            
        </div>
    )
}


interface CheckboxProps {
    value: boolean | undefined;
    label: string;
    name: string;
    inputError?: FormInputErrorEnum;
    valueSetter: (e: any) => void;
    required: boolean;
    className?: string;
    border?: boolean;
    p?: 'p05' | 'p1' | 'p2' | 'p3' | 'p4';
    textSize?: "base" | "xs" | "sm" | "lg" | "xl" | "xxl" | "xxxl" | "xxxxl" | undefined
}


export const LgFormCkeckBox: FC<CheckboxProps> = ({ value, label, name, inputError=null, required, valueSetter, className=' ', border=true, p='p3', textSize="base", ...props}) => {
    const errorClass = inputError === null ? '' : 'cs-input-error'
    return (
        <div className={`flex narrow-gap align-center ${border === true ? 'standart-border' : 'transparent-border'} r5 cs-input cs-input-lg ${className} ${errorClass} ${p}`}>
            <input
                id={name}
                name={name}
                type="checkbox"
                checked={value === undefined ? false : value}
                onChange={valueSetter}
                />
            <Text size={textSize} className='p0'>{label}{ required ? ( <span className='required-star'>*</span> ) : ('') } </Text>
            { inputError && <Text color='danger'>⚠️ {getErrorText(inputError)}</Text>}
        </div>
    )
}

export const PolicyFormCkeckBox: FC<CheckboxProps> = ({ value, name, label="", inputError=null, required, valueSetter, className=' ', border=true, p='p3', textSize="base", ...props}) => {
    const errorClass = inputError === null ? '' : 'cs-input-error'
    return (
        <div className={`flex narrow-gap align-center ${border === true ? 'standart-border' : 'transparent-border'} r5 cs-input cs-input-lg ${className} ${errorClass} ${p}`}>
            <input
                id={name}
                name={name}
                type="checkbox"
                checked={value === undefined ? false : value}
                onChange={valueSetter}
                />
            <Text size={textSize} className='p0'>Даю согласие на обработку персональных данных в соответствии с <DetailText href="/react/policy">Политикой конфиденциальности</DetailText> <span className='required-star'>*</span></Text>
            { inputError && <Text color='danger'>⚠️ {getErrorText(inputError)}</Text>}
        </div>
    )
}

export const SmFormCkeckBox: FC<CheckboxProps> = ({ value, label, name, inputError=null, required, valueSetter, className=' '}) => {
    return (
        <div className='flex narrow-gap align-center r5'>
            <input
                id={name}
                name={name}
                type="checkbox"
                checked={value === undefined ? false : value}
                onChange={valueSetter}
                />
            <Text size='base'>{label}{ required ? ( <span className='required-star'>*</span> ) : ('') } </Text>
            { inputError && <Text color='danger'>⚠️ {getErrorText(inputError)}</Text>}

        </div>
    )
}

interface SelectProps {
    value?: number | undefined;
    label: string;
    name: string;
    options: ChoicesProps[];
    inputError?: string;
    valueSetter?: (value: any) => void;
    className?: string;
}


export const LgSelect = ({ value, label, name, valueSetter, className="", options, ...props }:SelectProps):JSX.Element => {
    return (
        <div className="flex flex-column narrow-gap relative">
            <Text size="base">{label}</Text>
            <select id={name} name={name} className="cs-input cs-input-lg cs-select-large standart-border" defaultValue={value} value={value} onChange={valueSetter}>
                {options.map((option) => (
                    <option key={option.value} value={option.value}>
                        {option.label}
                    </option>
                ))}
            </select>
            <BoxWrapper style={{height: "17px"}} p="p0">
                { props.inputError ? (
                    <Text color='danger' size='sm' className='p0'>⚠️ {props.inputError}</Text> ):( <Text color='danger' size='sm' className='p0'>{''}</Text>
                )}
            </BoxWrapper>
        </div>

    )
}


interface FormFileProps {
    value?: any;
    serverFile?: string;
    label: string;
    name: string;
    inputError?: FormInputErrorEnum;
    valueSetter: (e: any) => void;
    required: boolean;
    helper?: string;
    className?: string;
    accept?: '' | 'application/pdf'
}


export const LgFileInput = ({ value, serverFile="", label, name, required, valueSetter, helper='', className='', accept=''}:FormFileProps):JSX.Element => {
    return (
        <div className="flex flex-column narrow-gap relative flex-grow" style={{width: '100%'}}>
            <Text size='base'>{label}</Text>
            <input 
                // value={value}
                className='cs-input cs-input-lg cs-file-button standart-border' 
                id={name} 
                name={name} 
                type="file" 
                accept={accept}
                onChange={valueSetter}
            />
            { serverFile ? <Tag>Текущий файл: {serverFile}</Tag> : <Tag>Файл не выбран</Tag> }
        </div>
    )
}

interface FormFilePropsv2 {
    id: string;
    value?: any;
    serverFile?: string;
    label: string;
    name: string;
    inputError?: FormInputErrorEnum;
    valueSetter: (e: any) => void;
    required: boolean;
    helper?: string;
    className?: string;
    accept?: '' | 'application/pdf';
    chooseFileText?: string;
    noFileText?: string;
    currentFileText?: string;
    fileNotSelectedText?: string;
}

export const LgFileInputV2 = ({
    id,
  value,
  serverFile = '',
  label,
  name,
  required,
  valueSetter,
  helper = '',
  className = '',
  accept = '',
  chooseFileText = 'Выбрать файл',
  noFileText = 'файл не выбран',
  currentFileText = 'Текущий файл',
  fileNotSelectedText = 'Файл не выбран',
}: FormFilePropsv2): JSX.Element => {
  const selectedName =
    value instanceof File
      ? value.name
      : value?.name || value?.target?.files?.[0]?.name || '';

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    valueSetter(e);
  };

  return (
    <div
      className={`flex flex-column narrow-gap relative flex-grow ${className}`}
      style={{ width: '100%' }}
    >
      <Text size="base">{label}</Text>

      <div className="cs-input cs-input-lg cs-file-button standart-border lg-file-input">
        <input
          id={id}
          name={name}
          type="file"
          accept={accept}
          required={required}
          onChange={handleChange}
          className="lg-file-input__native"
        />
        <label htmlFor={id} className="lg-file-input__btn">
          {chooseFileText}
        </label>
        <span className="lg-file-input__status">
          {selectedName || noFileText}
        </span>
      </div>

      {serverFile ? (
        <Tag>
          {currentFileText}: {serverFile}
        </Tag>
      ) : (
        <Tag>{fileNotSelectedText}</Tag>
      )}

      {helper ? <Text size="sm">{helper}</Text> : null}
    </div>
  );
};